import { HTTPResponse } from '../../../../services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '../../../../services/http'
import { IEquipmentModel, TCreateEquipmentModelDTO } from './equipmentModels.types.ts'

const getModels = async (): Promise<HTTPResponse<IEquipmentModel[]>> => {
  return http.get('/nsi/v1/equipment-models').then(handleHttpResponse).catch(handleHttpError)
}

const createModel = async (dto: TCreateEquipmentModelDTO): Promise<HTTPResponse<IEquipmentModel>> => {
  return http.post('/nsi/v1/equipment-models', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateModel = async (
  id: IEquipmentModel['id'],
  updates: Partial<IEquipmentModel>
): Promise<HTTPResponse<IEquipmentModel>> => {
  return http.patch(`/nsi/v1/equipment-models/${id}`, updates).then(handleHttpResponse).catch(handleHttpError)
}

const deleteModel = async (id: IEquipmentModel['id']): Promise<HTTPResponse<IEquipmentModel>> => {
  return http.delete(`/nsi/v1/equipment-models/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const equipmentModelsApi = { getModels, createModel, updateModel, deleteModel }
export default equipmentModelsApi
